/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from 'react';
import Button from '@mui/material/Button';
import BASESvgIcon from '../../@BASE/core/BASESvgIcon';

const ExportButton = ({ data }) => {
  const handleExport = () => {
    // Convert the data to JSON string
    const jsonData = JSON.stringify(data, null, 2);

    // Create a Blob object with the JSON data
    const blob = new Blob([jsonData], { type: 'application/json' });

    // Create a URL for the Blob object
    const url = URL.createObjectURL(blob);

    // Create a temporary link element
    const link = document.createElement('a');
    link.href = url;
    link.download = 'content.json'; // Set the filename for the downloaded file

    // Append the link to the document body and click it programmatically to trigger the download
    document.body.appendChild(link);
    link.click();

    // Clean up by removing the link and revoking the URL
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <Button
      variant="outlined"
      endIcon={
        <BASESvgIcon className="" size={20}>
          heroicons-solid:download
        </BASESvgIcon>
      }
      onClick={handleExport}
    >
      JSON
    </Button>
  );
};

export default ExportButton;
